import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Radio.css";

const valuesEqual = (a, b) => Object.is(a, b);

const Radio = ({
  label,
  value,
  onChange,
  options,
  withIcon,
  disabled,
  nameOnly,
}) => {
  const [selected, setSelected] = useState(value);
  const selectedRef = useRef(value);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    selectedRef.current = value;
    setSelected(value);
  }, [value]);

  const handleSelect = useCallback(
    (option) => {
      if (disabled || option.disabled) return;
      if (valuesEqual(selectedRef.current, option.value)) return;
      selectedRef.current = option.value;
      setSelected(option.value);
      onChangeRef.current?.(option.value);
    },
    [disabled],
  );

  return (
    <div className="radio">
      {label &&
        (nameOnly ? (
          <span className="radio-label">{label}</span>
        ) : (
          <h3 className="radio-label">
            <span className="radio-label">{label}</span>
          </h3>
        ))}
      {nameOnly && <span className="radio-for-nameonly"></span>}

      <div
        className={"radio-component" + (disabled ? " disabled" : "")}
        role="radiogroup"
      >
        {options?.map((option, index) => {
          const isActive = valuesEqual(selected, option.value);
          const isDisabled = Boolean(disabled || option.disabled);
          return (
            <div
              className={
                (isActive ? "activeRadio" : "radioItem") +
                (isDisabled ? " disabled" : "")
              }
              key={`${String(option.value)}-${index}`}
              role="radio"
              aria-checked={isActive}
              aria-disabled={isDisabled}
              onClick={() => handleSelect(option)}
            >
              {withIcon ? (
                <img className="radio-icon" src={option.icon} alt="" />
              ) : (
                option.label
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Radio;
